import React from 'react';
import * as styles from './TutorialModal.module.scss';
import Button from '../../components/Button';

interface TutorialModalProps {
  imageUrl?: string | null;
  title: string;
  message: React.ReactNode;
  additionalControls?: React.ReactNode;
  onPrimaryClick?: () => void;
  primaryButtonText?: string;
  onSecondaryClick?: () => void;
  secondaryButtonText?: string;
}

const TutorialModal = ({
  imageUrl = null,
  title,
  message,
  additionalControls = null,
  onPrimaryClick,
  primaryButtonText,
  onSecondaryClick,
  secondaryButtonText,
}: TutorialModalProps) => (
  <div className={styles.container}>
    {imageUrl && <img className={styles.headerImage} src={imageUrl} alt="" />}
    <div className={styles.content}>
      {title && <h4>{title}</h4>}
      {message}
    </div>
    <div className={styles.controls}>
      <div className={styles.additionalControls}>{additionalControls}</div>
      <Button
        className={styles.secondaryButton}
        onClick={onSecondaryClick}
        variant="muted"
      >
        {secondaryButtonText}
      </Button>
      {onPrimaryClick && (
        <Button variant="secondary" onClick={onPrimaryClick}>
          {primaryButtonText}
        </Button>
      )}
    </div>
  </div>
);

export default TutorialModal;
